import type {
  CustomRoute,
  ElegantRoute,
  GeneratedRoute,
} from "@elegant-router/types";
import { layouts, views } from "../elegant/imports";
import { transformElegantRoutesToVueRoutes } from "../elegant/transform";

export const ROOT_ROUTE: CustomRoute = {
  name: "root",
  path: "/",
  // redirect: getRoutePath(import.meta.env.VITE_ROUTE_HOME) || '/home',
  redirect: "/home",
  meta: {
    title: "root",
    constant: true,
  },
};

const ACCESS_DENIED_ROUTE: GeneratedRoute = {
  name: "403",
  path: "/403",
  component: "layout.blank$view.403",
  meta: {
    title: "403",
    i18nKey: "route.403",
    constant: true,
    hideInMenu: true,
  },
};

const NOT_FOUND_ROUTE: CustomRoute = {
  name: "not-found",
  path: "/:pathMatch(.*)*",
  component: "layout.blank$view.404",
  meta: {
    title: "not-found",
    constant: true,
  },
};

/** builtin routes, it must be constant and setup in vue-router */
const builtinRoutes: ElegantRoute[] = [
  ROOT_ROUTE,
  ACCESS_DENIED_ROUTE,
  NOT_FOUND_ROUTE,
];

/** create builtin vue routes */
export function createBuiltinVueRoutes() {
  return transformElegantRoutesToVueRoutes(builtinRoutes, layouts, views);
}
